import React, { FC } from "react";
import { useField, ErrorMessage } from "formik";

interface TextAreaProps {
  placeholder?: string;
  rows?: number;
  errors?:string;
  className?: string;
  [key:string]:any
}

const TextArea: FC<TextAreaProps> = ({ placeholder = '', rows = 6, className = '', errors , ...rest}) => {
  // console.log('ret',{rest})
  const [field,  meta] = useField(rest.name)
  // console.log({field, meta})
  return (
    <>
      <textarea
        className={`w-full resize-none rounded-3xl ${className} ${meta.touched && meta.error?'ring-2 ring-red-500/50':''}`}
        rows={rows}
        {...rest}
        {...field}
        placeholder={placeholder}
      />
      {
        meta.error && (<span className="text-xs text-red-400">{meta.error}</span>)
      }
    </>
  );
};

export default TextArea;
